<mat-dialog-content>
    <div class="block w-40 mx-auto text-center">
        <img class="w-full" [src]="this.data.imageUrl" alt="">
    </div>
    <div class="mt-4">
        <h5 class="text-[18px] mb-2 font-semibold text-[#045cd9]  text-center">{{this.data.title}}</h5>
       
    </div>
</mat-dialog-content>